__webpack_require__.p = "https://static.age.awaze.com/postbook-auth-mfe/ee291184b879fdbacdccd8eca86e27af27bf8571/_next/";